/*
 * Lógica pura del configurador de obra (sin DOM).
 * En el navegador queda en window.FRConfigurator; en Node se usa con require() para las pruebas (tests/).
 *
 * Forma del producto que emite el tema:
 *   { image: { width, height }, options: ['Tamaño', 'Marco'],
 *     variants: [{ id, options: ['90 x 60 cms', 'Madera Negra'], price (centavos), available }] }
 */
(function (root) {
  'use strict';

  var SIZE_OPTION = 'Tamaño';
  var FRAME_OPTION = 'Marco';
  var NO_FRAME = 'Solo Impresion';
  var MAX_PER_ORDER = 10;
  var SQUARE_TOLERANCE = 0.05;

  function parseSize(label) {
    var m = /(\d+)\s*x\s*(\d+)/i.exec(label || '');
    return m ? [Number(m[1]), Number(m[2])] : null;
  }

  function orientation(width, height) {
    if (!(width > 0 && height > 0)) return null;
    var r = width / height;
    if (r > 1 + SQUARE_TOLERANCE) return 'horizontal';
    if (r < 1 - SQUARE_TOLERANCE) return 'vertical';
    return 'cuadrada';
  }

  function productOrientation(product) {
    var img = product && product.image;
    return img ? orientation(img.width, img.height) : null;
  }

  // La orientación viene de la imagen, no de la etiqueta: hay productos con tamaños mal etiquetados.
  // 'cuadrada' o null se dibujan horizontal: el lado largo de la etiqueta va a lo ancho.
  function sizeCm(orient, label) {
    var s = parseSize(label);
    if (!s) return null;
    var lo = Math.min(s[0], s[1]);
    var hi = Math.max(s[0], s[1]);
    return orient === 'vertical' ? { w: lo, h: hi } : { w: hi, h: lo };
  }

  // Las opciones se buscan por nombre: un producto tiene el orden invertido (Marco, Tamaño).
  function optionValue(product, variant, name) {
    var i = product.options.indexOf(name);
    return i === -1 ? null : variant.options[i];
  }

  function longSide(label) {
    var s = parseSize(label);
    return s ? Math.max(s[0], s[1]) : Infinity;
  }

  function sizesOf(product) {
    var seen = [];
    product.variants.forEach(function (v) {
      var size = optionValue(product, v, SIZE_OPTION);
      if (size && seen.indexOf(size) === -1) seen.push(size);
    });
    return seen.sort(function (a, b) { return (longSide(a) - longSide(b)) || 0; });
  }

  function findVariant(product, size, frame) {
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if (optionValue(product, v, SIZE_OPTION) === size && optionValue(product, v, FRAME_OPTION) === frame) return v;
    }
    return null;
  }

  function priceOf(product, size, frame) {
    var v = findVariant(product, size, frame);
    return v ? v.price : null;
  }

  // Lo que cuesta el marco sobre la impresión sola, para ese tamaño.
  function frameDelta(product, size, frame) {
    var base = priceOf(product, size, NO_FRAME);
    var withFrame = priceOf(product, size, frame);
    return base === null || withFrame === null ? null : withFrame - base;
  }

  function edition(total, sold) {
    total = Number(total);
    if (!(total > 0)) return null;
    sold = Math.max(0, Number(sold) || 0);
    return { total: total, sold: sold, left: Math.max(0, total - sold), out: sold >= total };
  }

  function editionNumbers(sold, qty) {
    sold = Math.max(0, Number(sold) || 0);
    qty = Math.max(1, Number(qty) || 1);
    var first = sold + 1;
    return qty > 1 ? first + '–' + (sold + qty) : String(first);
  }

  function maxQty(left) {
    left = left === null || left === undefined ? NaN : Number(left);
    return isNaN(left) ? MAX_PER_ORDER : Math.min(MAX_PER_ORDER, Math.max(0, left));
  }

  var api = {
    SIZE_OPTION: SIZE_OPTION,
    FRAME_OPTION: FRAME_OPTION,
    NO_FRAME: NO_FRAME,
    parseSize: parseSize,
    orientation: orientation,
    productOrientation: productOrientation,
    sizeCm: sizeCm,
    optionValue: optionValue,
    sizesOf: sizesOf,
    findVariant: findVariant,
    priceOf: priceOf,
    frameDelta: frameDelta,
    edition: edition,
    editionNumbers: editionNumbers,
    maxQty: maxQty
  };

  root.FRConfigurator = api;
  if (typeof module === 'object' && module && module.exports) module.exports = api;
})(this);
